import PhaserMatterCollisionPlugin from "./phaser-matter-collision-plugin";

export default PhaserMatterCollisionPlugin;
